var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F2941B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31838 2.8125H9.32456C10.4901 3.96562 11.6426 5.13 12.8014 6.28931H15.6926L9.1845 15.5104C9.0765 14.4276 8.99325 13.3447 8.89762 12.2625C9.84037 10.9063 10.8084 9.5625 11.7512 8.2125L9.5985 6.06656C9.59657 5.81275 9.57533 5.55946 9.53494 5.30887C9.46463 4.48087 9.42019 3.6405 9.31838 2.8125ZM2.25619 12.0712C4.44038 9.00225 6.60544 5.92031 8.78344 2.84456L9.05737 6.10481C8.10844 7.461 7.15331 8.79862 6.20437 10.1486C6.91144 10.8551 7.61794 11.5746 8.33794 12.2816C8.43356 13.3639 8.51625 14.4596 8.62481 15.5486H8.61131L5.15362 12.0842C4.18612 12.0971 3.21806 12.078 2.25 12.0971V12.0712H2.25619Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStak);
export default __webpack_public_path__ + "static/media/stak.4c66eb0b392f25f22e4280d1b486c56e.svg";
export { ForwardRef as ReactComponent };